<div>
  @for (i of [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]; track i) {
  <person-icon
    [gender]="genderIcon"
    [class.active]="percentage >= i"
  ></person-icon>
  }
</div>

<div class="number">{{ percentage | number : '1.0-0' }}%</div>
